// eslint-disable-next-line
export const isEmail = email => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)

export const convertStringToCurrency = number => {
  return parseFloat(number).toFixed(2).replace(/./g, (c, i, a) => (
    i && c !== '.' && ((a.length - i) % 3 === 0) ? ',' + c : c
  ))
}

export const setStatusOfSchoolAdoptions = (role, status = 'approved_director') => (
  role === 'fractal_operator' ? 'pending' : status
)

export const hasBooksToBeSent = books => books.length > 0

export const formatRoleName = role => {
  return {
    'director': 'Diretor',
    'coordinator': 'Coordenador',
    'fractal_operator': 'Operador Fractal'
  }[role]
}



// WEBPACK FOOTER //
// ./src/utils/utils.js